import {
  Box,
  Heading,
  Flex,
  Input,
  IconButton,
  useToast,
  CloseButton,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Editor } from "react-draft-wysiwyg";
import styles_wysiwyg from "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { RichUtils, EditorState } from "draft-js";
import stylesEditor from ".././styles/wysiwyg.module.css";
import { AddIcon } from "@chakra-ui/icons";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setProductLink } from "../../../store/actions/productShowcaseAction";
import { useDispatch } from "react-redux";

const SectionBenefit = ({
  product,
  setProduct,
  benefit,
  setBenefit,
  validateBenefit,
  editorStateBenefitDescHandler,
  editorStateDesc,
}) => {
  const toast = useToast();
  const dispatch = useDispatch();

  const inputBenefitHandler = async (target, index) => {
    let tempBenefit = [...benefit];
    let { value, files } = target;

    if (target.name === "image") {
      const formData = new FormData();

      formData.append("image", files[0]);
      await dispatch(setProductLink(formData))
        .then((data) => {
          tempBenefit[index]["image"] = data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    } else {
      tempBenefit[index][target.name] = value;
    }
    setBenefit(tempBenefit);
  };

  const addBenefit = () => {
    const isValid = validateBenefit();
    if (isValid.status === "warning") {
      toast({
        title: "Warning.",
        description: isValid.message,
        status: isValid.status,
        position: "top",
        duration: 3000,
        isClosable: true,
      });
    } else {
      const tempObj = {
        title: "",
        image: "",
        description: "",
        editorState: EditorState.createEmpty(),
      };
      setBenefit([...benefit, tempObj]);
    }
  };

  const deleteBenefit = (i) => {
    let temp = [];
    benefit.forEach((each, idx) => {
      if (i !== idx) {
        temp.push(each);
      }
    });
    setBenefit(temp);
  };

  const moveBenefitOrder = (fromIndex, toIndex) => {
    let tempData = [...benefit];
    let benefitChanged = tempData[fromIndex];
    tempData.splice(fromIndex, 1);
    tempData.splice(toIndex, 0, benefitChanged);
    setBenefit(tempData);
  };

  const _uploadImageCallBack = (file) => {
    // convert to base64
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onerror = function (error) {
      console.error("Error onload: ", error);
    };

    return new Promise((resolve, reject) => {
      reader.onload = function () {
        resolve({
          data: {
            link: reader.result,
          },
        });
      };
    });
  };

  const _toggleBlockType = (blockType) => {
    this.onChange(RichUtils.toggleBlockType(editorStateDesc, blockType));
  };

  const onHandleDescriptionChange = (value) => {
    let tempProduct = { ...product };
    tempProduct.pdpBenefitDescription = value;
    setProduct(tempProduct);
  };

  const config = {
    image: {
      uploadCallback: _uploadImageCallBack,
      previewImage: true,
      alt: { present: true, mandatory: false },
      inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
    },
    list: {
      inDropdown: true,
      toggleBlockType: _toggleBlockType,
      unordered: { className: stylesEditor["unordered-list"] },
      ordered: { className: stylesEditor["ordered-list"] },
    },
    textAlign: { inDropdown: true },
    blockType: {
      className: "demo-option-custom-wide",
      dropdownClassName: "demo-dropdown-custom",
    },
  };

  return (
    <Card>
      <CardBody>
        <Row>
          <Col xl={12} style={{ marginBottom: "16px" }}>
            <Box
              style={{
                width: "100%",
                borderBottomWidth: "1px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                  color: "black",
                }}
              >
                Product Benefit
              </p>
            </Box>
            <div className="description-sm">
              <Heading as="h5" size="sm" mt="2rem" mb="0.5rem">
                Benefit List
              </Heading>
              {benefit.map((each, index) => (
                <Flex
                  key={index}
                  mb="2em"
                  borderRadius="md"
                  borderWidth="1px"
                  padding="12px"
                >
                  <Box flex={1}>
                    <Heading as="h5" size="sm" mb="0.5rem">
                      Benefit Title
                    </Heading>
                    <Input
                      type={"text"}
                      name={"title"}
                      placeholder={"Product Benefit Title"}
                      mb={"2"}
                      mt={"1"}
                      value={each.title}
                      onChange={(e) => inputBenefitHandler(e.target, index)}
                    />
                    <Heading as="h5" size="sm" margin="0.5rem 0">
                      Benefit Description
                    </Heading>
                    <Editor
                      editorState={each.editorState}
                      onEditorStateChange={(e) =>
                        editorStateBenefitDescHandler(e, index)
                      }
                      editorStyle={{ padding: "5px" }}
                      handlePastedText={() => false}
                      toolbarClassName={styles_wysiwyg["toolbarClassName"]}
                      wrapperClassName={styles_wysiwyg["wrapperClassName"]}
                      editorClassName={styles_wysiwyg["editorClassName"]}
                      toolbar={config}
                    />
                  </Box>

                  <Flex flexDirection="column">
                    <IconButton
                      isDisabled={index === 0}
                      icon={<ChevronUpIcon />}
                      colorScheme="teal"
                      size="sm"
                      margin={3}
                      onClick={() => moveBenefitOrder(index, index - 1)}
                    />
                    <IconButton
                      isDisabled={index === benefit.length - 1}
                      icon={<ChevronDownIcon />}
                      colorScheme="teal"
                      size="sm"
                      margin={3}
                      onClick={() => moveBenefitOrder(index, index + 1)}
                    />
                  </Flex>

                  <Box>
                    <CloseButton
                      style={{
                        height: "32px",
                        width: "32px",
                      }}
                      mt={3}
                      mr={3}
                      size="sm"
                      backgroundColor="#ff605c"
                      color="white"
                      onClick={() => deleteBenefit(index)}
                    />
                  </Box>
                </Flex>
              ))}
              <Flex justifyContent={"end"} marginTop={"8px"}>
                <IconButton
                  variant={"ghost"}
                  onClick={addBenefit}
                  icon={<AddIcon />}
                />
              </Flex>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default SectionBenefit;
